/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FOOTER STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	body: {
		// parent is inner in content_styles
		width: '100%',
		height: '100%',
		// padding: comes from body.js component (set top/bottom padding for body based on header and footer heights (so that they're 100% they're parent's height all together))
		position: 'relative',
		zIndex: '3',
		textAlign: 'left',
		// fontSize: hasRewardsComponent ? '90%' : '100%'
	}
};